module.exports = __webpack_public_path__ + "static/4_2_recommendation_BG-ad216231bd8fe78ba42ca8fe9d1d2525.svg";